import { withStyles, WithStyles } from "@mui/styles";
import style from "assets/jss/layouts/mobilePage/mobilePageStyle";
import * as React from "react";
import { WithTranslation, withTranslation } from "react-i18next";
import { RouteComponentProps } from "react-router-dom";
import Session from "services/Session";

////////////////////////////////////////////////////////////////////////////////////////////////////////

interface IAppProps {
    component: any;
    fullView?: boolean;
}

type Props = IAppProps & RouteComponentProps<any> & WithStyles<typeof style> & WithTranslation;

////////////////////////////////////////////////////////////////////////////////////////////////////////

class MobilePage extends React.PureComponent<Props> {
    private mainPanel: HTMLElement;

    constructor(props: Props) {
        super(props);
        if (props.i18n.language != Session.uiCulture) props.i18n.changeLanguage(Session.uiCulture);
    }

    //
    public componentDidUpdate(e: Props) {
        if (e.history.location.pathname !== e.location.pathname) {
            this.mainPanel.scrollTop = 0;
        }
    }

    //
    public render() {
        const { classes, component: Component, fullView, ...rest } = this.props;

        return (
            <div id="BlankPageView">
                <Component {...rest} />
            </div>
        );
    }
}

export default withTranslation()(withStyles(style)(MobilePage));